import { get, set, delete as unset } from 'dot-prop'
import cleanSchemaDefinedData from 'fanx-schema/utility/cleanSchemaDefinedData'
import createThirdPartyDataOverrides from './create-third-party-data-overrides.js'
import recursiveRemoveEmptyValues from '@fno/lib/recursive-remove-empty-values.js'
import stringifyKeys from 'stringify-keys'
import promiseAll from 'p-all'

import merge from '@fno/lib/merge'
import pick from '@fno/lib/pick'

const removable = [
    'id',
    'type'
]

const transformFormObjectToApiObject = ({ method, schema, data, original }) => {
    const dataWithoutEmpties = recursiveRemoveEmptyValues(data.attributes, {
        setToNull: true,
        ignoredKeypaths: data.attributes.$attributesToPreserve
    })

    const schemaCleanedAttributes = cleanSchemaDefinedData({
        data: dataWithoutEmpties,
        schema,
        removeNullValues: true
    })

    let attributes
    if (data.attributes.$attributesToPreserve) {
        // pick the attributesToPreserve and merge them into these results here so it's as if they weren't changed
        const ignoredKeypaths = pick(data.attributes.$attributesToPreserve, data.attributes)
        attributes = merge(schemaCleanedAttributes, ignoredKeypaths)
    } else {
        attributes = schemaCleanedAttributes
    }

    removable.forEach((key) => delete attributes[key])

    stringifyKeys(attributes).forEach((key) => {
        const originalValue = get(original, `attributes.${key}`)
        if (
            (originalValue === '' || (Array.isArray(originalValue) && !originalValue.length)) &&
            get(attributes, key) === null
        ) {
            unset(attributes, key)
        }
    })
    const cleanedResource = {
        id: data.id,
        type: data.type || schema.type,
        meta: data.meta,
        attributes
    }
    if (schema.properties.thirdPartyData && data.id) {
        cleanedResource.attributes.thirdPartyData = cleanedResource.attributes.thirdPartyData || {}
        cleanedResource.attributes.thirdPartyData.overrides = createThirdPartyDataOverrides({
            schema,
            cleanedForm: cleanedResource,
            original
        })
    }
    if (method === 'post') {
        delete cleanedResource.id
    }
    return cleanedResource
}

export default ({ component, page, context }) => {
    const saving = {}

    const makePromise = ({ formKey, index }) => {
        const saveKey = index === undefined ? formKey : `${formKey}.${index}`
        set(saving, saveKey, true)
        component.$set({ saving })

        const handle = ({ success, error }) => {
            set(saving, saveKey, false)
            component.$set({ saving })
            return { formKey, index, success, error }
        }

        const data = index === undefined ? context.form[formKey] : context.form[formKey][index]
        const method = data.$create ? 'post' : 'patch'

        return page[formKey][method](transformFormObjectToApiObject({
            method,
            schema: page[formKey].schema,
            data: data,
            original: index === undefined ? context.original[formKey] : context.original[formKey][index]
        }))
            .then((success) => handle({ success }))
            .catch((error) => handle({ error }))
    }

    const promises = Object
        .keys(page)
        .reduce((list, formKey) => {
            if (context.changes[formKey]) {
                if (page[formKey].type === Array) {
                    Object
                        .keys(context.changes[formKey])
                        .forEach(index => {
                            list.push(() => makePromise({ formKey, index }))
                        })
                } else {
                    list.push(() => makePromise({ formKey }))
                }
            }
            return list
        }, [])


    return promiseAll(promises, { concurrency: 5 })
        .then(responses => responses.reduce((map, { formKey, index, success, error }) => {
            set(map, index === undefined ? formKey : `${formKey}.${index}`, { success, error })
            return map
        }, {}))
}
